import React, { useState } from 'react'
import eye from '../../assets/icons/eyeBlack.svg'
import pen from '../../assets/icons/pen.svg'
import { AnimatePresence, motion } from 'framer-motion'
import PaymentDetails from './PaymentDetails'
import EditPaymnet from './EditPaymnet'
import changePymentStatus from '../../apis/changePymentStatus'

const PaymentCard = ({ payment, refresh }) => {
  const [isActive, setIsActive] = useState(payment.is_active === 1)
  const [active, setActive] = useState(false)
  const [edit, setEdit] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  const toggleSwitch = async () => {
    if (loading) return // Prevent multiple clicks while updating

    setLoading(true)
    setError('')
    setSuccess('')

    try {
      await changePymentStatus(payment.id, !isActive) // Send the updated status to API
      setIsActive((prev) => !prev)
      setSuccess('Payment status updated successfully.')
      refresh() // Refresh data
    } catch (err) {
      setError('Failed to update payment status.')
      console.error(err)
    } finally {
      setLoading(false)
      setTimeout(() => {
        setSuccess('')
        setError('')
      }, 3000) // Hide messages after 3 seconds
    }
  }

  return (
    <>
      <div className="border-[2px] border-blueButton gap-3 py-4 px-8 rounded-lg flex flex-col justify-center items-center space-y-4">
        <div className="text-blueButton text-xl">{payment.title}</div>
        <div className="text-blueButton">for: {payment.type}</div>

        {/* Toggle Switch */}
        <div className="flex items-center space-x-4">
          <span
            className={`${isActive ? 'text-blueButton/60' : 'text-blueButton'}`}
          >
            OFF
          </span>
          <div
            className={`relative inline-block w-14 h-7 rounded-full border-blueButton border-[1px] align-middle select-none transition duration-200 ease-in-out ${
              loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
            }`}
            onClick={!loading ? toggleSwitch : undefined} // Disable clicks while loading
          >
            <span
              className={`absolute left-0 -top-[0.5px] block w-6 h-6 mt-0.5 ml-0.5 rounded-full shadow transform transition-transform duration-200 ease-in-out ${
                isActive ? 'translate-x-6 bg-darkBlue' : 'bg-gray'
              }`}
            />
          </div>
          <span
            className={`${isActive ? 'text-blueButton' : 'text-blueButton/60'}`}
          >
            ON
          </span>
        </div>

        {/* Buttons */}
        <div className="flex justify-center items-center gap-4">
          <button
            onClick={() => setActive(true)}
            className="flex items-center space-x-2 w-8 h-8 border-[1px] rounded p-1 justify-center text-blueButton"
          >
            <img src={eye} alt="View" />
          </button>
          <button
            onClick={() => setEdit(true)}
            className="flex items-center space-x-2 w-8 h-8 border-[1px] rounded p-1 justify-center text-blueButton"
          >
            <img src={pen} alt="Edit" />
          </button>
        </div>

        {/* Success & Error Messages */}
      </div>

      <AnimatePresence>
        {success && (
          <motion.div
            className="fixed right-4 bottom-4 rounded bg-green text-white py-2 px-4"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
          >
            {success}
          </motion.div>
        )}
        {error && (
          <motion.div
            className="fixed right-4 bottom-4 rounded bg-red text-white py-2 px-4"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
          >
            {error}
          </motion.div>
        )}

        {active && (
          <PaymentDetails
            payment={payment}
            active={active}
            close={() => setActive(false)}
          />
        )}
        {edit && (
          <EditPaymnet
            payment={payment}
            active={edit}
            close={() => setEdit(false)}
            refresh={refresh}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default PaymentCard
